import React, { Suspense, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { getOnlineTraining } from "../../Services/SelfLearning";
import AddCourseToWishlist from "../AddCourseToWishlist/AddCourseToWishlist";
import { json } from "react-router";
import QuestionOption from "./OuestionOptionList";
const ComponentLoader = React.lazy(() => import("../../../../../Shared/Sidebar/ComponentLoader"));

function QuizList() {
    let userDetails = JSON.parse(localStorage.getItem("User") || '');
    const [lstModule, setlstModule] = useState([]);
    const [Isloading, setIsloading] = useState(false);
    const { CourseId } = useParams();
    const { ModuleId } = useParams();
    const [questionToShow, setQuestionLst] = useState([]);
    const [showSubmitBtn, setShowSubmitBtn] = useState(false);
    useEffect(() => {
        GetOnlineTraining();
    }, [])
    async function GetOnlineTraining() {
        setIsloading(true)
        let body = {
            "AccountId": userDetails?.OrgId,
            "LoggedInUserId": userDetails?.EmpId,
            "UserId": 0,
            "CourseId": Number(CourseId),
            "Search": "",
            "PageNumber": 1,
            "CategoryId": 0,
            "PageSize": 100,
            "NewOnly": 0,
            "BookmarkedOnly": 0,
            "FreeOnly": 0,
            "MyCourse": 0
        }
        try {
            let response = await getOnlineTraining(body);
            setIsloading(false)
            setlstModule(response.Data.courses[0]?.lstModules?.filter((lstModule) => { return lstModule.Id == ModuleId })?.[0]);//lstQuizQuestion

            if (lstModule) {
                setQuestionToShow(lstModule?.lstQuizQuestion[0]);
            }
        } catch (err) {
            setIsloading(false)
        }
    }

    useEffect(() => {
    },
        [lstModule]);

    function setQuestionToShow(el, index) {
        if (index === lstModule?.lstQuizQuestion.length - 1) {
            setShowSubmitBtn(true);
        } else {
            setShowSubmitBtn(false);
        }

        setQuestionLst(el)
    }
    return (
        <div className="position-relation">

            <div id="circular-menu" className="circular-menu">
                <a className="floating-btn" >
                    <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
                    <i aria-hidden="true" className="fa fa-times"></i>
                </a>

                <div className="items-wrapper">
                    <div className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </div>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="languages-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </a>
                    <Link to="" className="menu-item is-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
                    </Link>
                    <a className="menu-item is-flex right-panel-trigger" data-panel="activity-panel">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-grid"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                    </a>
                </div>

            </div>
            {/* <!-- row --> */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-8">
                        <div className="col-xl-12">
                            <div className="card position-rel">
                                <div className="card-body">
                                    <div className="block-header more-padding">
                                        <div className="coursedetail">
                                            <div className="des">
                                                {/* <h4 className="block-heading">{lstModule?.lstQuiz[0]?.QuizName} </h4> */}
                                                {/* <p className="block-text  mb-0">{lstModule?.CourseContent}</p> */}
                                            </div>
                                            <Link className="add-more" to={`/SelfLearningDashboard/CourseDetails/${CourseId}`}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25"
                                                    fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0
                                                  16 16"><path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.7
                                                  07l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5
                                                  .5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"></path></svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <img className="avatar position-ab" src="/images/org-img/learn/coursepng.png" alt="" />
                            </div>

                        </div>
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="" id="quizzes">
                                        <div className="">
                                            <ul className="rate">
                                                {lstModule?.lstQuizQuestion?.map((el, index) => (<>
                                                    {/*  className="check" */}
                                                    <li onClick={() => { setQuestionToShow(el, index) }}><span>{index + 1}</span></li>
                                                </>))}
                                            </ul>
                                            <QuestionOption question={questionToShow} showBtn={showSubmitBtn} />
                                        </div>
                                    </div></div></div>
                        </div>
                    </div>

                    <div className="col-xl-4">
                        <AddCourseToWishlist courseDetails={lstModule} />
                    </div>
                </div>
            </div>
            {
                Isloading ? <Suspense >
                <ComponentLoader />
            </Suspense> : ''
            }
        </div>
    )
}
export default QuizList;